import useTagPageStyles from './useTagPageStyles';
import TagView from './tag';
import useTagPage from '../../../hooks/useTagPage';
import AskQuestionButton from '../askQuestionButton';
import useLayoutStyles from '../../layout/useLayoutStyles';
import GameParrot from '../gameParrot';

/**
 * Represents the TagPage component which displays a list of tags
 * and provides functionality to handle tag clicks and ask a new question.
 */
const TagPage = () => {
  const { classes } = useTagPageStyles();
  const { classes: layoutClasses } = useLayoutStyles();

  const { tlist, clickTag } = useTagPage();

  return (
    <>
      <div className={layoutClasses.container}>
        <div className={`${layoutClasses.spaceBetween} ${layoutClasses.rightPadding}`}>
          <div className={layoutClasses.boldTitle}>{`All Tags (${tlist.length})`}</div>
          <AskQuestionButton />
        </div>
        <div className={`${classes.tagList}`}>
          {tlist.map((t, idx) => (
            <TagView key={idx} t={t} clickTag={clickTag} />
          ))}
        </div>
      </div>
      <GameParrot />
    </>
  );
};

export default TagPage;
